<template>
    <Pagebody :subnav="$store.getters.subnavNames" noborder>
        <div class="list">
            <div class="item" v-for="item in list" :key="item.id" @click="toDetail(item)">
                <div class="pic">
                    <img :src="item.pic">
                </div>
                <div>
                    <span class="price">￥{{item.price}}</span>&nbsp;&nbsp;{{unit(item.unit)}}
                </div>
                <div class="name">{{item.name}}</div>
                <div class="info">{{item.intro}}</div>
                <div class="buy"></div>
            </div>
        </div>
    </Pagebody>
</template>

<script>
    // @ is an alias to /src
    import pic1 from "@/assets/image/p_0.gif"
    export default {
        name: 'List',
        data: () => ({
            subnav: ["首页"],
            list: [{
                id: 3,
                price: 1200,
                name: "wh6",
                intro: "提供超长k线图表，支持手动下单附加算法交易部件，精细化控制下单过程",
                unit: 2,
                pic: pic1
            }, {
                id: 4,
                price: 12000,
                name: "wh7",
                intro: "提供超长k线图表，支持手动下单附加算法交易部件，精细化控制下单过程",
                unit: 1,
                pic: pic1
            }]
        }),
        methods: {
            unit(x) {
                const flag = {
                    1: '元/年/账号',
                    2: '元/年/人',
                    3: '元/年/套'
                }
                return flag[x]
            },
            toDetail(item) {
                this.$router.push({path: '/detail/'+item.id})
            }
        },
        components: {

        },
        mounted() {
            if (this.$route.query.name) {
                this.subnav.push(this.$route.query.name)
            }
        }
    }
</script>

<style scoped>
    .list {
        overflow: hidden;
    }

    .item {
        padding: 22px 17px 28px 17px;
        border: 1px solid #d9d9d9;
        border-top: 0;
        border-left: 0;
        float: left;
        cursor: pointer;
    }

    .item:first-child {
        border-left: 1px solid #d9d9d9;
    }

    .pic {
        padding-bottom: 9px;
    }

    .price {
        color: #a70000;
        font-weight: bolder;
        font-size: 14px;
    }

    .name {
        font-size: 13px;
        font-family: simsun;
        font-weight: bolder;
        padding-top: 1px;
        color: #343434;
        height: 44px;
        line-height: 44px;
    }

    .info {
        width: 205px;
        color: #6a6a6a;
        line-height: 15px;
        padding-top: 5px;
        height: 30px;
    }

    .buy {
        width: 103px;
        height: 24px;
        background: url(../../assets/image/buy.gif);
        display: block;
        margin: 12px 0 0 48px;
    }
</style>>